import { Tag, baseApi } from './base'

import { cacher } from '@/utils/rtkQueryCacheUtils'

export type AccountGroup = {
  _id: string
  description?: string
  establishment: string
  name: string
  policies: string[]
  totalAccounts: number
}

export type CreateAccountGroupParams = {
  accounts?: string[]
  establishment: string
  name: string
  policies?: string[]
}

type GetAccountGroupsParams = {
  name?: string
}

export type UpdateAccountGroupParams = Partial<Omit<CreateAccountGroupParams, 'establishment'>> & { id: string }

export const accountGroupApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    getAccountGroup: builder.query<AccountGroup, string>({
      query: (accountGroupId) => ({
        url: `/account-groups/${accountGroupId}`,
        method: 'GET',
      }),
    }),
    getAccountGroups: builder.query<AccountGroup[], GetAccountGroupsParams>({
      query: (params) => ({
        url: `/account-groups`,
        method: 'GET',
        params,
      }),
      providesTags: cacher.providesList(Tag.ACCOUNT_GROUP),
    }),
    createAccountGroup: builder.mutation<AccountGroup, CreateAccountGroupParams>({
      query: ({ accounts, ...accountGroup }) => ({
        url: '/account-groups',
        method: 'POST',
        body: { accountGroup, accounts },
      }),
      invalidatesTags: cacher.invalidatesList(Tag.ACCOUNT_GROUP),
    }),
    updateAccountGroup: builder.mutation<AccountGroup, UpdateAccountGroupParams>({
      query: ({ id: accountGroupId, accounts, ...accountGroup }) => ({
        url: `/account-groups/${accountGroupId}`,
        method: 'PUT',
        body: { accountGroup, accounts },
      }),
      async onQueryStarted({ id }, { dispatch, queryFulfilled }) {
        try {
          const { data: updatedAccountGroup } = await queryFulfilled
          dispatch(
            accountGroupApi.util.updateQueryData('getAccountGroup', id, (draftAccountGroup) => {
              Object.assign(draftAccountGroup, updatedAccountGroup)
            })
          )
        } catch (error) {
          console.log(error)
        }
      },
    }),
    deleteAccountGroup: builder.mutation<AccountGroup, string>({
      query: (accountGroupId) => ({
        url: `/account-groups/${accountGroupId}`,
        method: 'DELETE',
      }),
      invalidatesTags: cacher.invalidatesList(Tag.ACCOUNT_GROUP),
    }),
    deleteAccountGroups: builder.mutation<void, string[]>({
      query: (accountGroupIds) => ({
        url: '/account-groups/delete',
        method: 'POST',
        body: { ids: accountGroupIds },
      }),
      invalidatesTags: cacher.invalidatesList(Tag.ACCOUNT_GROUP),
    }),
  }),
  overrideExisting: false,
})
